export const enum LinkTarget {
  BLANK = '_blank',
  SELF = '_self',
}
